// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dJdIa","colMin":"styles_colMin__FkKzS"};